const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/gepartner.ts';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { KisApiAction, kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

export const ACTION_TYPE_CLEAR_GEPARTNER_SEARCH_RESULT = 'CLEAR_GEPARTNER_SEARCH_RESULTS';
export const LOAD_ARZT_PARTNER_RECORDS = kisapiActionTypes('PATAPP_LOAD_ARZT_PARTNER_RECORDS');
export const REQUEST_ACTION_TYPES_SEARCH_GEPARTNER = kisapiActionTypes('PATAPP_LOAD_SEARCH_GEPARTNER');

/**
 * Searches for Gepartner based on searchString
 */
// FIXME: remove that default rff which is just there to keep rff working the way it used to
export function getGepartnerSearchResults(searchString: string | null, componentId: string = 'rff') {
    const params = {
        searchString: searchString || '',
    };

    const queryString = new URLSearchParams(params).toString();
    const endpoint = `toberenamed/search/gepartner?${queryString}`;
    return createPatapiCall(
        REQUEST_ACTION_TYPES_SEARCH_GEPARTNER, //
        endpoint,
        HttpMethod.GET,
        { componentId, searchString }
    );
}

export function clearGepartnerSearchResults(componentId: string = 'rff') {
    return { type: ACTION_TYPE_CLEAR_GEPARTNER_SEARCH_RESULT, meta: { componentId } };
}

export function actionLoadGePartner(entityName: 'Arzt' | 'Garant' | 'Spital', fallNr: string) {
    const params = { EntityName: entityName, FALLNR: fallNr || '' };
    const queryString = new URLSearchParams(params).toString();
    const endpoint = `gepartner?${queryString}`;

    const meta = { fallNr, suppressErrorMsg: true };
    return createPatapiCall(LOAD_ARZT_PARTNER_RECORDS, endpoint, HttpMethod.GET, meta);
}

export type LoadGePartnerAction = KisApiAction<typeof actionLoadGePartner>;
